import React, { ReactElement, ReactNode } from 'react';
import { Box } from '@mui/material';

export interface IActivityOverlayChip {
  icon: ReactElement;
  label: ReactNode;
}

export const ActivityOverlayChip: React.FC<IActivityOverlayChip> = ({
  icon,
  label,
}): JSX.Element => {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1.25,
        py: 0.8,
        borderRadius: '999px',
        backgroundColor: 'rgba(0, 0, 0, 0.55)',
        color: 'common.white',
        fontSize: '0.75rem',
        lineHeight: 1.2,
        whiteSpace: 'nowrap',
        '& .MuiSvgIcon-root': {
          fontSize: '0.9rem',
          color: 'common.white',
        },
        '& strong': {
          fontWeight: 700,
          color: 'inherit',
        },
      }}
    >
      {icon}
      <Box component="span">{label}</Box>
    </Box>
  );
};
